export default function PageHeader({ overline, title, italic, description, image }) {
  return (
    <section
      data-testid="page-header"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden"
    >
      {image && (
        <div className="absolute inset-0 bg-teh-deep">
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
          <div className="absolute inset-0 bg-gradient-to-br from-teh-deep/90 via-teh-navy/75 to-teh-navy/55" />
        </div>
      )}
      {!image && (
        <div className="absolute inset-0 bg-gradient-to-br from-teh-surfaceAlt via-teh-bg to-white" />
      )}

      <div className="relative z-10 teh-container">
        <div className="max-w-4xl">
          {overline && (
            <p className={`text-xs font-semibold uppercase tracking-[0.22em] ${image ? "text-emerald-300" : "text-teh-green"}`}>
              {overline}
            </p>
          )}
          <h1 className={`font-serif text-5xl md:text-6xl lg:text-7xl mt-5 leading-[1.02] tracking-tight ${image ? "text-white" : "text-teh-deep"}`}>
            {title}
            {italic && (
              <>
                {" "}
                <span className={`italic ${image ? "text-emerald-300" : "text-teh-green"}`}>{italic}</span>
              </>
            )}
          </h1>
          {description && (
            <p className={`mt-8 text-lg md:text-xl max-w-2xl leading-relaxed ${image ? "text-white" : "text-teh-muted"}`}>
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
